import { useState, useMemo } from 'react'

//Styles
import Styles from './pilih-marketing-pembeli.module.scss'

//Components
import TextMedium from 'pages/dashboard/e-reporting/forms/components/reuseables/text-medium'
import Order from 'pages/dashboard/e-reporting/forms/components/reuseables/order'
import WrapperAndBox from 'pages/dashboard/e-reporting/forms/components/reuseables/wrapper-and-box/WrapperAndBox'
import SelectWithSearch from 'pages/dashboard/e-reporting/forms/components/reuseables/select-with-search/SelectWithSearch'
import ButtonSelanjutnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-selanjutnya/ButtonSelanjutnya'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

//hoc
import withFetch from './withFetch'

function PilihMarketingPembeli({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { isAprroval, form, isEditing } = useFormState()

  //State
  const [selectedData, setSelectedData] = useState({
    ...form.marketing_pembeli.value,
    value: form.marketing_pembeli.value.id,
    label: form.marketing_pembeli.value.full_name
  })

  const mappedData = useMemo(() => {
    if (!data?.length) return [];
    return data.map(datum => {
      return {
        value: datum.id,
        label: datum.full_name,
        ...datum
      }
    })
  }, [data])

  const onNext = () => {
    handlePrevState()
    formHandler('marketing_pembeli', selectedData)
    setCurrentStep(STEPS.entryCoListingPembeli)
  }

  return (
    <WrapperAndBox>
      <div className={Styles['title']}>
        <TextMedium required>
          Siapa marketing pembeli?
        </TextMedium>

      </div>
      <div className={Styles['select-wrapper']}>
        <SelectWithSearch selectedData={selectedData} disabled={isAprroval || isEditing} onClick={setSelectedData} options={mappedData} placeholder="Klik di sini atau klik simbol panah" />
        <BoxFlex>
          <>
            <ButtonSebelumnya />
            {selectedData.id !== null ? <ButtonSelanjutnya onClick={onNext} /> : null}
          </>
        </BoxFlex>
      </div>
    </WrapperAndBox>
  )
}

export default withFetch(PilihMarketingPembeli)